import { createLazyComponent } from '../shared/createLazyComponent';

// The GraphQL boundary, split out of the warm-while-closed graph (Seq G.4). A STATIC import
// would keep Apollo + data-sources in the warm chunk no matter that the component only renders
// after the first drawer-open: the module graph decides chunking, not the render tree. That is
// the whole reason this indirection exists.
//
// ⚠ It lives HERE rather than beside the other app-level importers in `app/dynamic-import.jsx`,
// because that module also imports `AssistantDataProvider`, which statically imports this
// folder's orchestrator — so importing it from the orchestrator closes a dependency cycle that
// `import/no-cycle` (rightly) rejects, dynamic hop or not. Each importer module belongs with the
// component that consumes it.
//
// No placeholder: `children` is the Shell, which is itself lazy, so the drawer already shows a
// loading state while its chunks arrive. `rethrowOnError` hands an exhausted-retry failure to
// the nearest ErrorBoundary instead of leaving an invisible unhandled rejection.
export const LazyAssistantDataLayer = createLazyComponent(
  () => import('./AssistantDataLayer'),
  'AssistantDataLayer',
  { label: 'Assistant Data Layer', rethrowOnError: true },
);
